// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"4362":"3367143ca293023b","9456":"3367143ca293023b"}[chunkId] + ".css";
};